import React, { createContext, useContext, useState } from 'react';
import {
  mockUser,
  mockMetrics,
  mockGMVTrend,
  mockGMVByChannel,
  mockGMVByCategory,
  mockSalesChannels,
  mockProductCategories
} from '../data/mockData';

const AppContext = createContext();

export const useAppContext = () => {
  const context = useContext(AppContext);
  if (!context) {
    throw new Error('useAppContext must be used within AppProvider');
  }
  return context;
};

export const AppProvider = ({ children }) => {
  const [user] = useState(mockUser);
  const [metrics] = useState(mockMetrics);
  const [gmvTrend] = useState(mockGMVTrend);
  const [gmvByChannel] = useState(mockGMVByChannel);
  const [gmvByCategory] = useState(mockGMVByCategory);
  const [salesChannels, setSalesChannels] = useState(mockSalesChannels);
  const [productCategories] = useState(mockProductCategories);
  const [notification, setNotification] = useState({ open: false, message: '', severity: 'success' });

  const addSalesChannel = (channel) => {
    const newChannel = {
      ...channel,
      id: salesChannels.length + 1,
      createdAt: new Date().toISOString().split('T')[0],
      status: 'active',
      configStatus: 'complete',
      monthlyGMV: 0
    };
    setSalesChannels([...salesChannels, newChannel]);
    showNotification('Sales channel created successfully!', 'success');
  };

  const updateSalesChannel = (id, updates) => {
    setSalesChannels(salesChannels.map(channel =>
      channel.id === id ? { ...channel, ...updates } : channel
    ));
    showNotification('Sales channel updated successfully!', 'success');
  };

  const showNotification = (message, severity = 'success') => {
    setNotification({ open: true, message, severity });
  };

  const hideNotification = () => {
    setNotification({ ...notification, open: false });
  };

  const value = {
    user,
    metrics,
    gmvTrend,
    gmvByChannel,
    gmvByCategory,
    salesChannels,
    productCategories,
    notification,
    addSalesChannel,
    updateSalesChannel,
    showNotification,
    hideNotification
  };

  return <AppContext.Provider value={value}>{children}</AppContext.Provider>;
};
